import { aAlly } from '@/api/ajax';

import createSearch from './createSearch';
import createTable from './createTable';
import createDetail from './createDetail';

const projectSearchList = {
  //type有2种值：1、医学助手联盟项目，2、医生汇项目；
  // type为1时，project_type有6种值：1学术拜访 2 OTC巡访 3 科室会 4 患教会 5 助手调查问卷 6 线上推广 9等级医院拜访 10基层医疗机构拜访；
  // type为2时，project_type有2种值：1 调查问卷 2 病例
  xsbf: { type: 1, projectType: 1, oneType: 1, twoType: 1 },
  otc: { type: 1, projectType: 2, oneType: 1, twoType: 2 },
  hzdy: { type: 1, projectType: 5, oneType: 1, twoType: 5 },
  ksh: { type: 1, projectType: 3, oneType: 1, twoType: 3 },
  hjh: { type: 1, projectType: 4, oneType: 1, twoType: 4 },
  xstg: { type: 1, projectType: 6, oneType: 1, twoType: 6 },
  blsj: { type: 2, projectType: 2, oneType: 2, twoType: 2 },
  yxdy: { type: 2, projectType: 1, oneType: 2, twoType: 1 },
  djyybf: { type: 1, projectType: 9, oneType: 1, twoType: 9 },
  jcyljg: { type: 1, projectType: 10, oneType: 1, twoType: 10 },
  tjsjyy: { type: 1, projectType: 10, oneType: 1, twoType: 10 },
  11: { type: 1, projectType: 11, oneType: 1, twoType: 11 },
  12: { type: 1, projectType: 12, oneType: 1, twoType: 12 },
  13: { type: 1, projectType: 13, oneType: 1, twoType: 13 },
  14: { type: 1, projectType: 14, oneType: 1, twoType: 14 },
  15: { type: 1, projectType: 15, oneType: 1, twoType: 15 },
  16: { type: 1, projectType: 16, oneType: 1, twoType: 16 },
  17: { type: 1, projectType: 17, oneType: 1, twoType: 17 },
  18: { type: 1, projectType: 18, oneType: 1, twoType: 18 },
  19: { type: 1, projectType: 19, oneType: 1, twoType: 19 },
  20: { type: 1, projectType: 20, oneType: 1, twoType: 20 }
};
/**
 * @description: 生成内容
 * @param {number}  税筹结构 【本次新增字段】  1 汇总申报  2 委托代开（线下）  3 委托代发  4 运营基地  5 个体    9  工具
 * @return: []
 */
const createContent = taxCollectionPattern => {
  return [
    {
      name: '学术拜访', // tab显示name
      marked: 'xsbf', // 该项唯一标识
      projectType: 1, // 类型
      childMenu: [
        // 子集 包含了任务记录与任务汇总
        {
          name: '任务记录', // tab显示name
          ex: true, // 导出1
          ctrl: true, // 是否显示操作 true显示
          // 搜索条件
          search: null,
          // table显示字段 四级个人、三级个体、三级个人使用同一套，
          fields: null,
          detailType: 'formDetail', // 详情组件名
          // 详情字段
          detailLimit: null
        }
      ]
    },
    {
      name: '等级医院拜访',
      marked: 'djyybf',
      projectType: 9,
      childMenu: [
        {
          name: '任务记录',
          ex: true,
          ctrl: true,
          search: null,
          fields: null,
          detailType: 'formDetail',
          detailLimit: null
        }
      ]
    },
    {
      name: '基层医疗机构拜访',
      marked: 'jcyljg',
      projectType: 10,
      childMenu: [
        {
          name: '任务记录',
          ex: true,
          ctrl: true,
          search: null,
          fields: null,
          detailType: 'formDetail',
          detailLimit: null
        }
      ]
    },
    {
      name: 'OTC拜访',
      marked: 'otc',
      projectType: 2,
      childMenu: [
        {
          name: '任务记录',
          ctrl: true,
          ex: true,
          search: null,
          fields: null,
          detailType: 'formDetail',
          detailLimit: null
        }
      ]
    },
    {
      name: '患者调研',
      marked: 'hzdy',
      projectType: 5,
      childMenu: [
        {
          name: '任务记录',
          ctrl: true,
          ex: true,
          ex2: true,
          search: null,
          fields: null,
          detailType: 'surveyDetail',
          // 这种要处理问卷信息
          detailLimit: [],
          checkImage: true
        }
      ]
    },
    {
      name: '科室会',
      marked: 'ksh',
      projectType: 3,
      childMenu: [
        {
          name: '任务记录',
          ctrl: true,
          ex: true,
          search: null,
          fields: null,
          detailType: 'formAjaxDetail',
          detailLimit: null,
          checkImage: true
        }
      ]
    },
    {
      name: '患教会',
      marked: 'hjh',
      projectType: 4,
      childMenu: [
        {
          name: '任务记录',
          ctrl: true,
          ex: true,
          search: null,
          fields: null,
          detailType: 'formAjaxDetail',
          detailLimit: null,
          checkImage: true
        }
      ]
    },
    {
      name: '线上推广',
      marked: 'xstg',
      projectType: 6,
      childMenu: [
        {
          name: '任务记录',
          ctrl: true,
          ex: true,
          ex2: true,
          exportText: '导出推广详情',
          ex3: true,
          export2Text: '导出给甲方',
          search: null,
          fields: null,
          detailType: 'tableDetail',
          // 这种要处理问卷信息
          detailLimit: []
        },
        {
          name: '任务汇总',
          ex: true,
          search: null,
          /**
         POST /rest/crm/oss/onlinepro/tasksummary OSS 线上推广 任务汇总 出参：[{服务商、项目名称、任务月度、项目参与人、手机号、(taskSum)计划任务量、实际完成量(finishSum)、未完成量(uncompletedQuantity)、审核通过量(finishSum)、任务完成率completionRate(实际完成量/计划任务量)}]
         * */
          fields: null
        }
      ]
    },
    {
      name: '特级三甲医院市场准入',
      marked: '11',
      projectType: 11,
      childMenu: [
        {
          name: '任务记录',
          ex: true,
          ctrl: true,
          search: null,
          fields: null,
          detailType: 'formDetail',
          detailLimit: null,
          checkImage: true
        }
      ]
    },
    {
      name: '三级医院市场准入',
      marked: '12',
      projectType: 12,
      childMenu: [
        {
          name: '任务记录',
          ex: true,
          ctrl: true,
          search: null,
          fields: null,

          detailType: 'formDetail',
          detailLimit: null,
          checkImage: true
        },
        {
          name: '任务汇总',
          ex: true,
          ctrl: false,
          search: null,
          fields: null
        }
      ]
    },
    {
      name: '二级医院市场准入',
      marked: '13',
      projectType: 13,
      childMenu: [
        {
          name: '任务记录',
          ex: true,
          ctrl: true,
          search: null,
          fields: null,
          detailType: 'formDetail',
          detailLimit: null,
          checkImage: true
        },
        {
          name: '任务汇总',
          ex: true,
          ctrl: false,
          search: null,
          fields: null
        }
      ]
    },
    {
      name: '基层医疗机构市场准入',
      marked: '14',
      projectType: 14,
      childMenu: [
        {
          name: '任务记录',
          ex: true,
          ctrl: true,
          search: null,
          fields: null,
          detailType: 'formDetail',
          detailLimit: null,
          checkImage: true
        }
      ]
    },
    {
      name: '零售药店市场准入',
      marked: '15',
      projectType: 15,
      childMenu: [
        {
          name: '任务记录',
          ex: true,
          ctrl: true,
          search: null,
          fields: null,

          detailType: 'formDetail',
          detailLimit: [],
          checkImage: true
        }
      ]
    },
    {
      name: '医学调研',
      marked: 'yxdy',
      projectType: 7,
      childMenu: [
        {
          name: '任务记录',
          ctrl: true,
          ex: true,
          ex2: true,
          search: null,
          fields: null,
          detailType: 'surveyDetail',
          detailLimit: null,
          checkImage: true
        }
      ]
    },
    {
      name: '医学病例收集',
      marked: 'blsj',
      projectType: 8,
      childMenu: [
        {
          name: '任务记录',
          ctrl: true,
          ex: true,
          search: null,
          fields: null,
          detailType: 'formDetail',
          detailLimit: null
        }
      ]
    },
    {
      name: '病例收集',
      marked: '18',
      projectType: 18,
      childMenu: [
        {
          name: '任务记录',
          ctrl: true,
          ex: true,
          search: null,
          fields: null,
          detailType: 'formDetail',
          detailLimit: null,
          checkImage: true
        }
      ]
    },
    {
      name: '数字拜访',
      marked: '17',
      projectType: 17,
      childMenu: [
        {
          name: '任务记录',
          ctrl: true,
          ex: true,
          search: null,
          fields: null,
          detailType: 'digitDetail',
          detailLimit: null
        }
      ]
    },
    //协定服务
    {
      name: '协定服务',
      marked: '19',
      projectType: 19,
      childMenu: [
        {
          name: '任务记录',
          ctrl: false,
          ex: true,
          search: null,
          fields: null,
          detailType: 'digitDetail',
          detailLimit: null
        }
      ]
    },
    {
      name: '可配置场景',
      marked: '20',
      projectType: 20,
      childMenu: [
        {
          name: '任务记录',
          ctrl: true,
          ex: true,
          search: null,
          fields: null,
          detailType: 'makeSceneDetail',
          detailLimit: null,
          checkImage: true
        }
      ]
    }
  ].map(res => {
    // 添加查询过滤
    res.searchCtrl = projectSearchList[res.marked];
    // 添加对应数据字段
    res.childMenu.forEach((item, index) => {
      let type = `${res.projectType}_${index}`;
      item.search = createSearch(type, taxCollectionPattern); // 搜索字段
      item.fields = createTable(type, taxCollectionPattern); // 列表字段
      item.detailLimit = createDetail(type, taxCollectionPattern); // 详情字段
    });
    return res;
  });
};

export default createContent;
